import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestRoutes } from '../_config/rest-routes.config';
import { StateTransitionsModel } from '../_models/state-transitions.model';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class StateTransitionsService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        'Content-type': 'application/json'
      }
    )
  };

  constructor(private http: HttpClient) { }


  getStateTransitions(id:any): Observable<StateTransitionsModel[]> {
    let url: string = `${environment.urlWS}${RestRoutes.STATE_TRANSITIONS.replace('{ID}',id)}`;
    //let url: string = `${environment.urlWS}${RestRoutes.STATE_TRANSITIONS}${id}${RestRoutes.STATE_TRANSITIONS2}`;
    // console.log(url)
    return this.http.get<StateTransitionsModel[]>(url, this.httpOptions);
  }
}
